module.exports = __webpack_public_path__ + "static/media/8.e99e9a97.jpg";